import { BrowserRouter, Route, Routes } from 'react-router';
import { Home } from './Home';
import { useState } from 'react';
import { List } from './List';

export const AppRouter = () => {
  const [isNew, setIsNew] = useState<boolean>(false);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home setIsNew={setIsNew} />} />
        <Route path="/list/:channelId" element={<List isNew={isNew} />} />
        <Route path="*" element={<Home setIsNew={setIsNew} />} />
      </Routes>
    </BrowserRouter>
  );
};
